import { render, staticRenderFns } from "./buindingLeftTop.vue?vue&type=template&id=3bb0b9c1&"
import script from "./buindingLeftTop.vue?vue&type=script&lang=js&"
export * from "./buindingLeftTop.vue?vue&type=script&lang=js&"
import style0 from "./buindingLeftTop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports